import { connect } from 'react-redux';
import PageView from './index'


const mapStateToProps = (state, props) => {
    
    return {
	pages: state.pages.list
    }
}

const mapDispatchToProps = (dispatch, state) => {
  
    return {

    }
}

const PageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PageView);




export default PageContainer;



// WEBPACK FOOTER //
// ./src/components/Page/Container.js